import { CLEAR_ERRORS } from './../constants';

export const clearErrors = () => {
  return { type: CLEAR_ERRORS };
};
